/*
 * @Author: Dom
 * @Date: 2022-05-30 15:49:05
 * @LastEditTime: 2022-07-21 00:13:52
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\views\addlogistics\store.ts
 */
import { Mutation, Action } from 'vuex';
import { StoreModuleType } from "@/utils/store";
import { ResponseData } from '@/utils/request';

import {getSkuPageList, saveSku, getPageList, createOrder, validInfo} from './service'
import {AddTableDataType, TableListQueryParams, TableDataType, TableDataTypel, InitDataType, validInfoType} from './data.d'


export interface StateType {
    errorMsg?: string;
    tableData: AddTableDataType;
    formdata: any;
    getAddList: TableDataType;
    getAddListl: TableDataTypel;
    getAddListSelect: TableDataType;
    getAddListlSelect: TableDataTypel;
    submitData: any;
    validInfoData: any;
}

export interface ModuleType extends StoreModuleType<StateType>{
    state: StateType;
    mutations: {
        changeErrorMsg: Mutation<StateType>;
        getSkuList: Mutation<StateType>;
        getFormData: Mutation<StateType>;
        getList: Mutation<StateType>;
        getListl: Mutation<StateType>;
        getListSelect: Mutation<StateType>;
        getListlSelect: Mutation<StateType>;
        getValidInfo: Mutation<StateType>;
    };
    actions: {
        getSkuPageListFn: Action<StateType, StateType>;
        saveSkuFn: Action<StateType, StateType>;
        getPageListFn: Action<StateType, StateType>;
        getPageListSendFn: Action<StateType, StateType>;
        submitDataFn: Action<StateType, StateType>;
        getValidInfoFn: Action<StateType, StateType>;
    };
}

const initState: StateType = {
    errorMsg: undefined,
    tableData: {
        skulist: [],
        pagination: {
            total: 0,
            current: 1,
            pageNo: 1,
            pageSize: 10,
            showSizeChanger: true,
            showQuickJumper: true,
        },
    },
    formdata: {},
    getAddList: {
        addResslist: [],
    },
    getAddListl: {
        addsendlist: [],
    },
    getAddListSelect: {
        addResslist: [],
    },
    getAddListlSelect: {
        addsendlist: [],
    },
    submitData:{},
    validInfoData: {}
}

const StoreModel: ModuleType = {
    namespaced: true,
    name: 'addlogistics',
    state: {
        ...initState
    },
    mutations: {
        changeErrorMsg(state, payload) {
            state.errorMsg = payload;
        },
        getSkuList(state, payload){
            state.tableData = payload
        },
        getFormData(state, payload){
            state.formdata = payload
        },
        getList(state, payload){
            state.getAddList.addResslist = payload
        },
        getListl(state, payload){
            state.getAddListl.addsendlist = payload
        },
        getListSelect(state, payload){
            state.getAddListSelect.addResslist = payload
        },
        getListlSelect(state, payload){
            state.getAddListlSelect.addsendlist = payload
        },
        getValidInfo(state, payload){
            state.validInfoData = payload
        }
    },
    actions: {
        //获取sku列表信息
        async getSkuPageListFn({commit}, params:TableListQueryParams){
            let msg: string | undefined = undefined
            try{
                const req: ResponseData = await getSkuPageList(params)
                const { body } = req
                const data = body?.datas
                const list:any[] = [];
                data&&data.map((item:any) => {
                    if(item.declareNumber < 0){
                        item.declareNumber = 1
                    }
                })
                data&&data.forEach((item:any) => {
                    list.push({...item,isflag:false})
                });
                commit('getSkuList', {
                    ...initState.tableData,
                    skulist: list || [],
                    pagination: {
                        ...initState.tableData.pagination,
                        current: params.pageNo,
                        pageNo: params.pageNo,
                        pageSize: params.pageSize,
                        total: body.sumDataCount || 0
                    }
                })
                msg = '';
            }catch(error:any){
                if (error.message && error.message === 'CustomError') {
                    const { response } = error;
                    const { data } = response;
                    msg = data.msg || 'error';
                }
            }
            commit('changeErrorMsg',msg);
            if (msg === '') {
                return true; // 成功
            } else if (typeof msg === 'undefined') {
                return undefined; // 服务器错误
            } else {
                return false; // 自定义错误
            }
        },
        
        //保存sku
        async saveSkuFn({commit}, params:TableListQueryParams){
            let msg: string | undefined = undefined
            try{
                await saveSku(params)
                msg = '';
            }catch(error:any){
                if (error.message && error.message === 'CustomError') {
                    const { response } = error;
                    const { data } = response;
                    msg = data.msg || 'error';
                }
            }
            commit('changeErrorMsg',msg);
            if (msg === '') {
                return true; // 成功
            } else if (typeof msg === 'undefined') {
                return undefined; // 服务器错误
            } else {
                return false; // 自定义错误
            }
        },
        //获取收件人信息列表信息
        async getPageListFn({commit}, params:TableListQueryParams){
            let msg: string | undefined = undefined
            try{
                const req: ResponseData = await getPageList(params)
                const { body } = req
                const data = body || []
                let alist:any[] = []
                data.length != 0 && data.forEach((item:any) => {
                    if(item.isDefault){
                        alist.push(item)
                    }
                })
                commit('getList', alist)
                commit('getListSelect', data)
                msg = '';
            }catch(error:any){
                if (error.message && error.message === 'CustomError') {
                    const { response } = error;
                    const { data } = response;
                    msg = data.msg || 'error';
                }
            }
            commit('changeErrorMsg',msg);
            if (msg === '') {
                return true; // 成功
            } else if (typeof msg === 'undefined') {
                return undefined; // 服务器错误
            } else {
                return false; // 自定义错误
            }
        },
        //获取揽收地址列表信息
        async getPageListSendFn({commit}, params:TableListQueryParams){
            let msg: string | undefined = undefined
            try{
                const req: ResponseData = await getPageList(params)
                const { body } = req
                const data = body || []
                let alist:any[] = []
                data.length != 0 && data.forEach((item:any) => {
                    if(item.isDefault){
                        alist.push(item)
                    }
                })
                commit('getListl', alist)
                commit('getListlSelect', data)
                msg = '';
            }catch(error:any){
                if (error.message && error.message === 'CustomError') {
                    const { response } = error;
                    const { data } = response;
                    msg = data.msg || 'error';
                }
            }
            commit('changeErrorMsg',msg);
            if (msg === '') {
                return true; // 成功
            } else if (typeof msg === 'undefined') {
                return undefined; // 服务器错误
            } else {
                return false; // 自定义错误
            }
        },
        //创建物流订单
        async submitDataFn({commit}, params:InitDataType){
            let msg: string | undefined = undefined
            try{
                await createOrder(params)
                msg = '';
            }catch(error:any){
                if (error.message && error.message === 'CustomError') {
                    const { response } = error;
                    const { data } = response;
                    msg = data.msg || 'error';
                }
            }
            commit('changeErrorMsg',msg);
            if (msg === '') {
                return true; // 成功
            } else if (typeof msg === 'undefined') {
                return undefined; // 服务器错误
            } else {
                return false; // 自定义错误
            }
        },

        //查询日期有效的币种兑换汇率详情
        async getValidInfoFn({commit}, params:validInfoType){
            let msg: string | undefined = undefined
            try{
                const req: ResponseData = await validInfo(params)
                const { body } = req
                console.log('exch-body', body);
                const data = body || {}
                // console.log('getValidInfo', data.exchangeScale)
                commit('getValidInfo', data.exchangeScale)
                msg = '';
            }catch(error:any){
                if (error.message && error.message === 'CustomError') {
                    const { response } = error;
                    const { data } = response;
                    msg = data.msg || 'error';
                }
            }
            commit('changeErrorMsg',msg);
            if (msg === '') {
                return true; // 成功
            } else if (typeof msg === 'undefined') {
                return undefined; // 服务器错误
            } else {
                return false; // 自定义错误
            }
        },
    }
}

export default StoreModel
